import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("am_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function resolveImg(src) {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  if (src.startsWith("/api")) return `${BACKEND_URL}${src}`;
  return src;
}

export function fmtRON(n) {
  return new Intl.NumberFormat("ro-RO", { maximumFractionDigits: 0 }).format(Math.round(n)) + " lei";
}

export function apiError(detail) {
  if (detail == null) return "A apărut o eroare. Încearcă din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
